<!--
 * @Description: 应用库管理专家列表
 * @Author: 钱磊
 * @Date: 2022-07-25 14:17:30
 * @LastEditors: git config user.name
 * @LastEditTime: 2025-09-12 15:54:52
-->
<template>
  <div class="h100 Apage">
    <filter-layout @search="doSearch" @reset="doRefresh" hasMore>
      <template #filter>
        <el-form
          class="flex-row-form colspan-4"
          size="small"
          ref="searchForm"
          label-width="100px"
          :model="searchObj"
        >
          <el-form-item label="姓名：" label-width="60px">
            <el-input
              :placeholder="'请输入'"
              clearable
              v-model="searchObj.sname"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号：">
            <el-input
              :placeholder="'请输入'"
              clearable
              v-model="searchObj.phone"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="证件类型：">
            <el-select
              v-model="searchObj.cardType"
              placeholder="请选择证件类型"
              clearable
              size="small"
            >
              <el-option
                v-for="(item, index) in smzjlx"
                :key="'类型' + index"
                :label="item.sname"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号码：" prop="idCard">
            <el-input
              :placeholder="'请输入'"
              clearable
              v-model="searchObj.idCard"
              size="small"
            ></el-input>
          </el-form-item>
        </el-form>
      </template>
      <template #more>
        <el-form
          class="flex-row-form colspan-4"
          size="small"
          ref="searchForm"
          label-width="100px"
          :model="searchObj"
        >
          <el-form-item label="性别：" label-width="60px">
            <el-select
              v-model="searchObj.sex"
              placeholder="请选择性别"
              clearable
              size="small"
            >
              <el-option label="女" :value="0"></el-option>
              <el-option label="男" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select
              v-model="searchObj.status"
              placeholder="请选择状态"
              clearable
              size="small"
            >
              <el-option label="禁用" :value="0"></el-option>
              <el-option label="启用" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年龄：" class="w50">
            <div style="display: flex">
              <el-input
                :placeholder="'请输入'"
                clearable
                v-model="searchObj.lAge"
                size="small"
              ></el-input>

              <span class="text-center pd5">~</span>

              <el-input
                :placeholder="'请输入'"
                clearable
                v-model="searchObj.gAge"
                size="small"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="专业：" label-width="60px">
            <el-cascader
              v-model="searchObj.specialty"
              :key="resouseKey"
              :options="dataTree"
              size="small"
              :disabled="optionsChanged"
              :show-all-levels="false"
              :props="{
                checkStrictly: true,
                emitPath: false,
                value: 'id',
                label: 'sname',
              }"
              clearable
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="入库时间：" prop="applyBus" class="w50">
            <div style="display: flex">
              <el-date-picker
                class="w100"
                v-model="searchObj.startTime"
                type="date"
                placeholder="请选择时间"
                size="small"
                value-format="yyyy-MM-dd"
                :editable="false"
                :clearable="true"
                :picker-options="startDatePicker"
              ></el-date-picker>
              <span class="text-center pd5">~</span>
              <el-date-picker
                class="w100"
                v-model="searchObj.endTime"
                type="date"
                placeholder="请选择时间"
                size="small"
                value-format="yyyy-MM-dd 23:59:59"
                :editable="false"
                :clearable="true"
                :picker-options="endDatePicker"
              ></el-date-picker>
            </div>
          </el-form-item>
        </el-form>
      </template>
      <template #content>
        <div class="w-table-layout w-table-page mt10">
          <div class="w-table-content" v-show="tableShow">
            <vxe-table
              :data="tableObj.tableData"
              :loading="tableObj.loading"
              :border="tableObj.border"
              :resizable="tableObj.resizable"
              :size="tableObj.size"
              :height="tableObj.height"
              highlight-current-row
              highlight-hover-row
              show-overflow="tooltip"
              v-show="tableShow"
              show-header-overflow="tooltip"
            >
              <vxe-table-column
                type="seq"
                title="序号"
                align="center"
                width="70"
              ></vxe-table-column>
              <vxe-table-column
                field="sname"
                title="姓名"
                width="110"
                align="center"
              ></vxe-table-column>
              <vxe-table-column
                field="phone"
                title="手机号码"
                width="100"
                align="center"
              ></vxe-table-column>
              <vxe-table-column
                field="cardName"
                title="证件类型"
                width="100"
                align="center"
              ></vxe-table-column>
              <vxe-table-column
                field="idCard"
                title="证件号码"
                width="160"
                align="center"
              ></vxe-table-column>
              <vxe-table-column
                field="sex"
                title="性别"
                width="80"
                align="center"
              >
                <template v-slot="{ row }">
                  {{ row.sex ? "男" : "女" }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="age"
                title="年龄"
                width="80"
                align="center"
              ></vxe-table-column>
              <vxe-table-column
                field="specialtyName"
                title="专业"
                align="center"
              >
                <template v-slot="{ row }">
                  {{ row.specialtyName | specialChange }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="createDate"
                title="入库时间"
                width="140"
                align="center"
              ></vxe-table-column>
              <vxe-table-column title="状态" align="center" width="90">
                <template v-slot="{ row }">
                  <vxe-switch
                    v-model="row.status"
                    open-label="启用"
                    :open-value="1"
                    close-label="关闭"
                    :close-value="0"
                    @change="changeStatus(row)"
                  ></vxe-switch>
                </template>
              </vxe-table-column>
              <vxe-table-column title="操作" width="90" align="center">
                <template v-slot="{ row }">
                  <el-button
                    type="success"
                    size="small"
                    round
                    plain
                    class="table-btn"
                    @click="handleCheck(row)"
                    icon="el-icon-view"
                    >查看
                  </el-button>
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
          <div class="w-table-footer">
            <vxe-pager
              size="mini"
              :current-page="searchObj.current"
              :page-size="searchObj.size"
              :total="searchObj.totalResult"
              class="text-center"
              :page-sizes="[10, 20, 50, 100]"
              :layouts="[
                'Total',
                'Sizes',
                'PrevPage',
                'JumpNumber',
                'NextPage',
                'FullJump',
              ]"
              @page-change="handlePageChange"
            >
            </vxe-pager>
          </div>
        </div>
      </template>
    </filter-layout>
  </div>
</template>

<script>
import {
	getBaseStatus,
	getLibExpertList,
	getSpecialtyList,
} from "api/modules/expert_gz.js";
// import AddSetting from "./components/AddSetting";
import { mapState } from "vuex";

export default {
  components: {},
  props: {
    leftRowId: {
      type: String,
      default: "",
    },
  },
  filters: {
    specialChange(val) {
      if (val) {
        let values = val.replace(/,/g, "/");
        return values;
      } else {
        return "-";
      }
    },
    timeFilter(val) {
      if (val) {
        return val.split(" ")[0];
      }
    },
  },
  data() {
    return {
      showFilter: true,
      searchObj: {
        libId: "", //专家库id
        sname: "", // 专家名称
        phone: "", //手机号
        idCard: "", //证件号码
        cardType: "", //证件类型
        startTime: "", //开始时间
        endTime: "", //结束时间
        status: "", //状态
        sex: "", //性别
        lAge: "", //开始年龄
        gAge: "", //结束年龄
        specialty: "", //z专业
        current: 1, // 当前页码
        size: 10, // 当前每页条数
        totalResult: 0,
      },
      // 表格对象
      tableObj: {
        tableData: [],
        loading: false,
        border: true,
        resizable: true,
        size: "small",
        height: "100%",
      },
      searchToggle: true, //筛选控制
      tableShow: true, //表格显隐控制
      startDatePicker: this.beginDate(),
      endDatePicker: this.processDate(),
      dataTree: [], //专家专业列表
      optionsChanged: false, //级联选择器是否禁用（如果专家专业是空的，则禁用）
      resouseKey: 1, //级联选择器的key值
    };
  },
  created() {
    // 如果是 返回的
    if (this.$getSessionItem("searchObj")) {
      this.searchObj = JSON.parse(this.$getSessionItem("searchObj"));
      // 移除 避免污染
      this.$removeSessionItem("searchObj");
    }
    if (this.leftRowId != "") {
      this.getSpecialtyList();
      this.doSearch();
    }
  },
  methods: {
    // 查询评价设置列表
    doSearch(page) {
      if (this.leftRowId == "") {
        this.$message.warning("请先创建应用库！");
        return;
      }
      if (page) {
        this.searchObj.size = 10;
        this.searchObj.current = 1;
      }
      this.tableObj.loading = true;
      let params = Object.assign(this.searchObj);
      params.libId = this.leftRowId;
      getLibExpertList(params)
        .then((res) => {
          this.tableObj.loading = false;
          this.tableObj.tableData = res.data.records;
          this.searchObj.totalResult = parseInt(res.data.total);
        })
        .catch((err) => {
          this.tableObj.loading = false;
        });
    },
    // 查询专家专业类别
    getSpecialtyList() {
      this.searchObj.specialty = "";
      ++this.resouseKey;
      getSpecialtyList({ libId: this.leftRowId }).then((res) => {
        if (res.operationCode == 1) {
          if (res.data !== null) {
            this.dataTree = res.data;
            this.optionsChanged = false;
          } else {
            this.optionsChanged = true;
          }
        }
      });
    },
    //刷新/重置
    doRefresh() {
      this.searchObj.size = 10;
      this.searchObj.current = 1;
      this.searchObj.sname = "";
      this.searchObj.phone = "";
      this.searchObj.idCard = "";
      this.searchObj.cardType = "";
      this.searchObj.startTime = "";
      this.searchObj.endTime = "";
      this.searchObj.status = "";
      this.searchObj.sex = "";
      this.searchObj.lAge = "";
      this.searchObj.gAge = "";
      this.searchObj.specialty = "";
      this.doSearch();
    },

    // 修改应用库专家状态
    changeStatus(row) {
      row.status = row.status ? 0 : 1;
      getBaseStatus({ userId: row.userId }).then((res) => {
        if (res.operationCode == 1) {
          if (res.data.status != 1) {
            this.$message.warning(
              "该名专家基础库已被停用，固所在的所有应用库皆不可以被使用！"
            );
          }
          setTimeout(() => {
            this.$emit("handleChange", row);
          }, 300);
        }
      });
    },

    // 开始时间的 pickOption
    beginDate() {
      let that = this;
      return {
        disabledDate(time) {
          let endTime = "";
          endTime = new Date(that.searchObj.endDate).getTime() + 86400000;
          if (endTime) {
            // eslint-disable-next-line no-undef
            return bmElementTimeOptins.limitDateBefore(time, endTime, false);
          } else {
            return time.getTime() > Date.now();
          }
        },
      };
    },

    // 结束时间的 pickOption
    processDate() {
      let that = this;
      return {
        disabledDate(time) {
          let startTime = "";
          startTime = new Date(that.searchObj.startDate).getTime() - 86400000;
          if (startTime) {
            let nowTime = Date.now() + 86400000;
            // eslint-disable-next-line no-undef
            return bmElementTimeOptins.limitDateInRange(
              time,
              startTime,
              nowTime,
              false
            );
          } else {
            return time.getTime() > Date.now();
          }
        },
      };
    },
    // 右侧操作
    handleCheck(row) {
      let data = {
        id: row.userId,
        searchObj: this.searchObj,
      };
      this.$emit("setId", data);
    },

    // 切换分页
    handlePageChange({ currentPage, pageSize }) {
      this.searchObj.current = currentPage;
      this.searchObj.size = pageSize;
      this.doSearch();
    },
  },
  computed: {
    routeQuery() {
      return this.$route.query.type;
    },
    ...mapState("app", { isBack: (state) => state.isBack }),
    ...mapState("dict", {
      smzjlx: (state) => state.smzjlx,
    }),
  },
  watch: {
    // 监听 筛选元素的 切换展示 重新调整表格高度
    searchToggle() {
      this.tableShow = false;
      setTimeout(() => {
        this.tableShow = true;
      }, 50);
    },
  },
};
</script>

<style>
.pd5{
  padding: 0 5px;
}
</style>
